/**
 * Loads the app afresh at its front door. Whatever the old page was still waiting for goes with it.
 */
export const restartApp = () => {
  window.location.replace('/');
};
